import React, { Component, Fragment } from "react";
import logo from "../resources/images/logo_arousa_norte.png";
import { Grid, Button, TextField, Card } from "material-ui";
import * as mainActions from "../actions/mainActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { login } from "../controllers/login";
import { toast } from "react-toastify";
import createHistory from "history/createBrowserHistory";

export const bHistory = createHistory();
class Login extends Component {
    constructor(props) {
        super(props);
        // Set default values to debug purposes
        this.state = {
            userName: "",
            passwd: ""
        };
    }

    componentDidMount() {
        const sessionData = sessionStorage.getItem("session");
        if (bHistory.location.pathname !== "/login" && !sessionData)
            bHistory.push("/login");
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = event => {
        if (event.keyCode === 13)
            this.login(this.state.userName, this.state.passwd);
    };

    changeValue = event => {
        let object = {};
        object[event.nativeEvent.target.name] = event.nativeEvent.target.value;
        this.setState(object);
    };

    login = async (userName, passwd) => {
        try {
            if (userName === "" || passwd === "")
                return toast("Introduce un usuario e un contrasinal.", {
                    className: "toast-error",
                    autoClose: 3000
                });
            await login(userName, passwd);
            this.props.onLogin();
        } catch (err) {
            if (err.status === 403)
                return toast("O usuario ou o contrasinal son incorrectos.", {
                    className: "toast-error",
                    autoClose: 3000
                });
            else if (err.status === 500)
                return toast(
                    "Erro de conexión co servidor, intenteo de novo máis tarde",
                    { className: "toast-error", autoClose: 3000 }
                );
        }
    };

    render() {
        const { userName, passwd } = this.state;
        return (
            <Fragment>
                <Grid container spacing={0} justify="center">
                    <header style={{ textAlign: "center", backgroundColor: "rgb(34, 34, 34)", padding: "4em", color: "white", width: "100%" }}>
                        <img src={logo} style={{ height: '80px' }} alt="logo" />
                    </header>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Card style={{ minWidth: '500px', maxWidth: '50%', padding: '2.5em', margin: '3em auto' }}>
                        <div
								style={{
									marginBottom: 0,
									paddingBottom: 0,
									fontWeight: "600",
									fontSize: "1.25em"
								}}
							>
								{`Iniciar sesión`}
							</div>
                            <TextField
                                id="userName"
                                name="userName"
                                label="Usuario"
                                margin="normal"
                                value={userName}
                                onChange={this.changeValue}
                                fullWidth={true}
                            />
                            <TextField
                                id="passwd"
                                name="passwd"
                                label="Contrasinal"
                                margin="normal"
                                value={passwd}
                                type="password"
                                onChange={this.changeValue}
                                fullWidth={true}
                            />
                            <Button
                                variant="raised"
                                color="primary"
                                style={{marginTop: '2em'}}
                                onClick={() => {
                                    this.login(userName, passwd);
                                }}
                                fullWidth={true}>
                                Iniciar sesión</Button>
                        </Card>
                    </div>
                </Grid>
            </Fragment>
        );
    }
}

//Connect state to use default test values
const mapStateToProps = state => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js